




















































import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import ProjectStatusMixin from '@/mixins/ProjectStatusMixin';
import { StatusFilter } from '@/interfaces';
import { Getter, Mutation } from 'vuex-class';

@Component
export default class ProjectsOverview extends Mixins(
  OverviewMixin,
  ProjectStatusMixin
) {
  public tableCfg = FieldDefs;
  public version = 1;
  public statusFilter: StatusFilter = {};

  @Getter('getProjectStatusId')
  public getProjectStatusId!: () => number;

  @Mutation('setProjectStatusId')
  public setProjectStatusId;

  public setFilter(statusId) {
    this.statusFilter.last_projecteventtype_id = statusId;
    this.filterChanged();
  }

  public filterChanged() {
    this.version += 1;
    this.setProjectStatusId(this.statusFilter.last_projecteventtype_id);
  }

  public async downloadProjectOverview() {
    const data = {
      filter: this.getFilterValues(),
      sort: this.getSortString()
    };
    this.api.downloadAction(this.$store, '/projects/export_overview', data);
  }

  // Lifecycle Functions
  public created() {
    this.statusFilter.last_projecteventtype_id = this.getProjectStatusId();
  }
}
